/**
 * Quality 模块常量定义（自动生成）
 * 
 * ⚠️ 此文件由 api:export-types 命令自动生成
 * ⚠️ 请勿手动编辑！如需修改，请修改后端代码后重新生成
 * 
 * 包含：
 * - 枚举标签映射（中文）
 * - 权限常量定义
 * 
 * 验证规则请查看 validations.ts
 * 
 * @generated 2025-12-04T05:00:10.271969Z
 * @generator api:export-types v1.0.0
 */

import { AQLStandardLEVEL, AQLStandardSTATUS, InspectionItemTYPE, InspectionItemVALUE, InspectionItemSTATUS, InspectionRecordRESULT, InspectionTaskTYPE, InspectionTaskSOURCE, InspectionTaskSTATUS, InspectionTaskRESULT, InspectionTemplateTYPE, InspectionTemplateSAMPLING, InspectionTemplateSTATUS, NCRLogACTION, NCROrderSOURCE, NCROrderLEVEL, NCROrderDISPOSITION, NCROrderSTATUS, SelfInspectionConfigFREQ, SelfInspectionConfigUNIT, SelfInspectionConfigSTATUS } from './enums'

// ==================== 枚举标签映射 ====================

/**
 * AQLStandard级别 标签映射
 */
export const A_Q_L_STANDARD_L_E_V_E_L_LABELS = {
  [AQLStandardLEVEL.S1]: 'S1',
  [AQLStandardLEVEL.S2]: 'S2',
  [AQLStandardLEVEL.S3]: 'S3',
  [AQLStandardLEVEL.S4]: 'S4',
  [AQLStandardLEVEL.I]: 'I',
  [AQLStandardLEVEL.II]: 'II',
  [AQLStandardLEVEL.III]: 'III',
} as const

/**
 * AQLStandard状态 标签映射
 */
export const A_Q_L_STANDARD_S_T_A_T_U_S_LABELS = {
  [AQLStandardSTATUS.DISABLED]: 'DISABLED',
  [AQLStandardSTATUS.ENABLED]: 'ENABLED',
} as const

/**
 * InspectionItem类型 标签映射
 */
export const INSPECTION_ITEM_T_Y_P_E_LABELS = {
  [InspectionItemTYPE.DIMENSION]: 'DIMENSION',
  [InspectionItemTYPE.VISUAL]: 'VISUAL',
  [InspectionItemTYPE.FUNCTIONAL]: 'FUNCTIONAL',
  [InspectionItemTYPE.WEIGHT]: 'WEIGHT',
  [InspectionItemTYPE.HARDNESS]: 'HARDNESS',
  [InspectionItemTYPE.TENSILE]: 'TENSILE',
  [InspectionItemTYPE.APPEARANCE]: 'APPEARANCE',
  [InspectionItemTYPE.PACKAGING]: 'PACKAGING',
  [InspectionItemTYPE.OTHER]: 'OTHER',
} as const

/**
 * InspectionItemVALUE 标签映射
 */
export const INSPECTION_ITEM_V_A_L_U_E_LABELS = {
  [InspectionItemVALUE.TYPE_NUMERIC]: 'TYPE_NUMERIC',
  [InspectionItemVALUE.TYPE_BOOLEAN]: 'TYPE_BOOLEAN',
  [InspectionItemVALUE.TYPE_TEXT]: 'TYPE_TEXT',
  [InspectionItemVALUE.TYPE_OPTION]: 'TYPE_OPTION',
} as const

/**
 * InspectionItem状态 标签映射
 */
export const INSPECTION_ITEM_S_T_A_T_U_S_LABELS = {
  [InspectionItemSTATUS.ENABLED]: 'ENABLED',
  [InspectionItemSTATUS.DISABLED]: 'DISABLED',
} as const

/**
 * InspectionRecordRESULT 标签映射
 */
export const INSPECTION_RECORD_R_E_S_U_L_T_LABELS = {
  [InspectionRecordRESULT.QUALIFIED]: 'QUALIFIED',
  [InspectionRecordRESULT.REJECTED]: 'REJECTED',
} as const

/**
 * InspectionTask类型 标签映射
 */
export const INSPECTION_TASK_T_Y_P_E_LABELS = {
  [InspectionTaskTYPE.IQC]: 'IQC',
  [InspectionTaskTYPE.IPQC]: 'IPQC',
  [InspectionTaskTYPE.OQC]: 'OQC',
  [InspectionTaskTYPE.SELF]: 'SELF',
  [InspectionTaskTYPE.PATROL]: 'PATROL',
  [InspectionTaskTYPE.FIRST_ARTICLE]: 'FIRST_ARTICLE',
  [InspectionTaskTYPE.RECHECK]: 'RECHECK',
} as const

/**
 * InspectionTaskSOURCE 标签映射
 */
export const INSPECTION_TASK_S_O_U_R_C_E_LABELS = {
  [InspectionTaskSOURCE.RECEIVING]: 'RECEIVING',
  [InspectionTaskSOURCE.WORK_ORDER]: 'WORK_ORDER',
  [InspectionTaskSOURCE.WORK_REPORT]: 'WORK_REPORT',
  [InspectionTaskSOURCE.PRODUCTION_BATCH]: 'PRODUCTION_BATCH',
  [InspectionTaskSOURCE.MANUAL]: 'MANUAL',
} as const

/**
 * InspectionTask状态 标签映射
 */
export const INSPECTION_TASK_S_T_A_T_U_S_LABELS = {
  [InspectionTaskSTATUS.PENDING]: 'PENDING',
  [InspectionTaskSTATUS.IN_PROGRESS]: 'IN_PROGRESS',
  [InspectionTaskSTATUS.COMPLETED]: 'COMPLETED',
  [InspectionTaskSTATUS.CANCELLED]: 'CANCELLED',
} as const

/**
 * InspectionTaskRESULT 标签映射
 */
export const INSPECTION_TASK_R_E_S_U_L_T_LABELS = {
  [InspectionTaskRESULT.QUALIFIED]: 'QUALIFIED',
  [InspectionTaskRESULT.REJECTED]: 'REJECTED',
  [InspectionTaskRESULT.CONDITIONAL]: 'CONDITIONAL',
} as const

/**
 * InspectionTemplate类型 标签映射
 */
export const INSPECTION_TEMPLATE_T_Y_P_E_LABELS = {
  [InspectionTemplateTYPE.IQC]: 'IQC',
  [InspectionTemplateTYPE.IPQC]: 'IPQC',
  [InspectionTemplateTYPE.OQC]: 'OQC',
  [InspectionTemplateTYPE.SELF]: 'SELF',
  [InspectionTemplateTYPE.PATROL]: 'PATROL',
  [InspectionTemplateTYPE.FIRST_ARTICLE]: 'FIRST_ARTICLE',
} as const

/**
 * InspectionTemplateSAMPLING 标签映射 - 抽样类型
 */
export const INSPECTION_TEMPLATE_S_A_M_P_L_I_N_G_LABELS = {
  [InspectionTemplateSAMPLING.FULL]: '全检',
  [InspectionTemplateSAMPLING.SAMPLING]: '固定数量抽检',
  [InspectionTemplateSAMPLING.AQL]: 'AQL抽样',
  [InspectionTemplateSAMPLING.FIRST_ARTICLE]: '首件',
  [InspectionTemplateSAMPLING.SKIP]: '免检',
} as const

/**
 * InspectionTemplate状态 标签映射
 */
export const INSPECTION_TEMPLATE_S_T_A_T_U_S_LABELS = {
  [InspectionTemplateSTATUS.ENABLED]: 'ENABLED',
  [InspectionTemplateSTATUS.DISABLED]: 'DISABLED',
} as const

/**
 * NCRLogACTION 标签映射
 */
export const N_C_R_LOG_A_C_T_I_O_N_LABELS = {
  [NCRLogACTION.CREATE]: 'CREATE',
  [NCRLogACTION.UPDATE]: 'UPDATE',
  [NCRLogACTION.SUBMIT]: 'SUBMIT',
  [NCRLogACTION.CONFIRM]: 'CONFIRM',
  [NCRLogACTION.ASSIGN]: 'ASSIGN',
  [NCRLogACTION.SUBMIT_DISPOSITION]: 'SUBMIT_DISPOSITION',
  [NCRLogACTION.APPROVE]: 'APPROVE',
  [NCRLogACTION.REJECT]: 'REJECT',
  [NCRLogACTION.EXECUTE]: 'EXECUTE',
  [NCRLogACTION.EXECUTE_FAILED]: 'EXECUTE_FAILED',
  [NCRLogACTION.CLOSE]: 'CLOSE',
  [NCRLogACTION.CANCEL]: 'CANCEL',
  [NCRLogACTION.REOPEN]: 'REOPEN',
  [NCRLogACTION.ADD_REMARK]: 'ADD_REMARK',
  [NCRLogACTION.UPLOAD_ATTACHMENT]: 'UPLOAD_ATTACHMENT',
} as const

/**
 * NCROrderSOURCE 标签映射
 */
export const N_C_R_ORDER_S_O_U_R_C_E_LABELS = {
  [NCROrderSOURCE.IQC]: 'IQC',
  [NCROrderSOURCE.IPQC]: 'IPQC',
  [NCROrderSOURCE.OQC]: 'OQC',
  [NCROrderSOURCE.SELF]: 'SELF',
  [NCROrderSOURCE.PATROL]: 'PATROL',
  [NCROrderSOURCE.FIRST_ARTICLE]: 'FIRST_ARTICLE',
  [NCROrderSOURCE.CUSTOMER]: 'CUSTOMER',
  [NCROrderSOURCE.LPA]: 'LPA',
  [NCROrderSOURCE.OTHER]: 'OTHER',
} as const

/**
 * NCROrder级别 标签映射（缺陷等级）
 */
export const N_C_R_ORDER_L_E_V_E_L_LABELS = {
  [NCROrderLEVEL.CRITICAL]: '严重',
  [NCROrderLEVEL.MAJOR]: '主要',
  [NCROrderLEVEL.MINOR]: '轻微',
} as const

/**
 * NCROrderDISPOSITION 标签映射（处置方式）
 */
export const N_C_R_ORDER_D_I_S_P_O_S_I_T_I_O_N_LABELS = {
  [NCROrderDISPOSITION.SCRAP]: '报废',
  [NCROrderDISPOSITION.REWORK]: '返工',
  [NCROrderDISPOSITION.RETURN]: '退货',
  [NCROrderDISPOSITION.CONCESSION]: '让步接收',
  [NCROrderDISPOSITION.DOWNGRADE]: '降级使用',
  [NCROrderDISPOSITION.USE_AS_IS]: '照常使用',
  [NCROrderDISPOSITION.SORT]: '挑选使用',
} as const

/**
 * NCROrder状态 标签映射（方案A优化后的显示文本）
 */
export const N_C_R_ORDER_S_T_A_T_U_S_LABELS = {
  [NCROrderSTATUS.DRAFT]: '草稿',
  [NCROrderSTATUS.PENDING_CONFIRM]: '待确认',
  [NCROrderSTATUS.PENDING_REVIEW]: '待指派', // 优化：原"待评审"
  [NCROrderSTATUS.REVIEWING]: '评审中',
  [NCROrderSTATUS.PROCESSING]: '分析中', // 优化：原"处理中"
  [NCROrderSTATUS.PENDING_APPROVAL]: '方案待批', // 优化：原"待审批"
  [NCROrderSTATUS.APPROVED]: '待执行', // 优化：原"已审批"
  [NCROrderSTATUS.REJECTED]: '方案驳回', // 优化：原"已驳回"
  [NCROrderSTATUS.EXECUTED]: '执行完成', // 优化：原"已执行"
  [NCROrderSTATUS.EXECUTION_FAILED]: '处置异常', // 下游单据创建失败，待重试
  [NCROrderSTATUS.CLOSED]: '已关闭',
  [NCROrderSTATUS.CANCELLED]: '已取消',
} as const

/**
 * SelfInspectionConfigFREQ 标签映射
 */
export const SELF_INSPECTION_CONFIG_F_R_E_Q_LABELS = {
  [SelfInspectionConfigFREQ.BY_TIME]: 'BY_TIME',
  [SelfInspectionConfigFREQ.BY_QUANTITY]: 'BY_QUANTITY',
  [SelfInspectionConfigFREQ.BY_BATCH]: 'BY_BATCH',
} as const

/**
 * SelfInspectionConfig单位 标签映射
 */
export const SELF_INSPECTION_CONFIG_U_N_I_T_LABELS = {
  [SelfInspectionConfigUNIT.MINUTE]: 'MINUTE',
  [SelfInspectionConfigUNIT.HOUR]: 'HOUR',
  [SelfInspectionConfigUNIT.SHIFT]: 'SHIFT',
} as const

/**
 * SelfInspectionConfig状态 标签映射
 */
export const SELF_INSPECTION_CONFIG_S_T_A_T_U_S_LABELS = {
  [SelfInspectionConfigSTATUS.DISABLED]: 'DISABLED',
  [SelfInspectionConfigSTATUS.ENABLED]: 'ENABLED',
} as const

